<template>
  <div class="search-sidebar__content">
    <search-commons
      v-if="sidebarStatus === 'filter'"
      @toggle-sidebar="toggleSidebar"
    />

    <search-classifiers
      v-if="sidebarStatus === 'classifiers'"
      @return="toggleSidebar('classifiers')"
    />

    <search-checklists
      v-if="sidebarStatus === 'checklists'"
      @return="toggleSidebar('checklists')"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import SearchCommons from './SearchCommons';
import SearchClassifiers from './SearchClassifiers';
import SearchChecklists from './SearchChecklists';

export default {
  components: {
    SearchCommons,
    SearchClassifiers,
    SearchChecklists
  },

  computed: {
    ...mapGetters([
      'sidebarStatus'
    ])
  },

  methods: {
    toggleSidebar(status) {
      status = this.sidebarStatus===status? 'filter' :status;
      this.$store.dispatch('setSidebarStatus', status);
    }
  }
};
</script>
